/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { usePartnerContext } from "../../../../context/partner/PartnerContext";
import { pushOnePartner } from "../../../../middlewares/sysNavigation/SysNavigation";
import { Modal, Search, MyButton, Pagination } from "../../component/Component";

const addRoute = "/partner/add";
const editRoute = "/partner/edit";

const Overview = () => {
  const [partnerList, setPartnerList] = useState([]);
  const { partner, fetchPartners, count } = usePartnerContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!partner) fetchPartners();
    else setPartnerList(partner);
  }, [partner]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (partner !== null && partner !== undefined)
      partner.map((ptner) => {
        if (ptner?.name.toString().toLowerCase().includes(key))
          return searchArray.push(ptner);
        return true;
      });

    setPartnerList(searchArray);
    if (key === "") setPartnerList(partner);
  };

  const hasData = Array.isArray(partnerList) && partnerList.length > 0;

  return (
    // Preserve original scroll behavior to avoid overflow regressions
    <div className="p-3 lg:p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-7xl">
        {/* Header */}
        <div className="mb-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Partners
              </h1>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Manage organizations showcased on your site.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                Items: {hasData ? partnerList.length : 0}
              </span>
              <Link to={addRoute}>
                <MyButton
                  title="Add Partner"
                  onClick={() => { }}
                  className="rounded-lg bg-gray-800 px-3 py-2 text-xs font-semibold shadow-sm transition hover:bg-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-500"
                />
              </Link>
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4">
          <Search
            props={{
              title: "Partner",
              onChange: (e) => SearchList(e),
            }}
          />
        </div>

        {/* Table card */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Name
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Description
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 text-center font-semibold text-gray-700">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {partner ? (
                  hasData ? (
                    partnerList.map((ptner) => (
                      <tr
                        key={ptner?.partner_id}
                        className="transition-colors hover:bg-gray-50"
                      >
                        <td className="px-4 py-3 align-top text-gray-900 break-words whitespace-pre-line">
                          {ptner?.name}
                        </td>
                        <td className="px-4 py-3 align-top text-gray-700">
                          <div className="max-w-[60ch] whitespace-pre-line break-words">
                            {ptner?.description}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <ActionButton props={ptner} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="px-4 py-8 text-center text-sm text-gray-500" colSpan={3}>
                        No partners yet.
                      </td>
                    </tr>
                  )
                ) : (
                  // Loading skeleton to preserve layout while fetching
                  Array.from({ length: 3 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-3">
                        <div className="h-4 w-40 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-64 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="mx-auto h-9 w-20 rounded-lg bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchPartners(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { partner, updatePartnerState, deletePartner } = usePartnerContext();

  const [showModal, setShowModal] = useState(false);

  const partner_id = props.partner_id;
  const partner_name = props.name;
  const ptner = props;

  const deleteOnePartnerById = async (partner_id) => {
    const { status } = await deletePartner(partner_id);
    if (status === 200) {
      if (partner) {
        const update = partner.filter(
          (ptner) => ptner?.partner_id !== partner_id
        );
        updatePartnerState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: partner_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOnePartnerById(partner_id),
        }}
      />

      <div className="flex items-center justify-center gap-2 px-2 py-3 text-xs">
        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className="rounded-lg bg-blue-600 px-3 py-2 font-semibold shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            onClick={() => pushOnePartner(ptner)}
          />
        </Link>
        <MyButton
          title="Delete"
          className="rounded-lg bg-red-600 px-3 py-2 font-semibold shadow-sm transition hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
